import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout} from '../../../api';
import {CheckoutInputElement} from '../inputs/checkoutInputs';
import {openLink} from '../../../util';

@observer
export default class CheckoutAccount extends React.Component {
    @observable pwd: string = '';
    @observable expandSignIn: boolean;
    @observable loading: boolean = false;

    constructor(props) {
        super(props);
        this.signin = this.signin.bind(this);
        this.expandSignIn = false;
        makeObservable(this);
    }

    @action
    signin = async () => {
        this.loading = true;
        const success = await checkout('acct-login');
        this.loading = false;
        if (store.checkout.isMyFrames) {
            openLink('/Identity/Account/Login');
        }
    };

    componentDidMount() {
        if (store.PortalID === 3) {
            store.moveStep(ICheckoutStep.oci);
        }
    }

    render() {
        return (
            <div>
                <div
                    className="checkout-header"
                    style={{color: store.PortalID === 3 ? '#33393a' : '', backgroundColor: store.PortalID === 3 ? '#edece9' : ''}}
                >
                    <span>Checkout Method</span>
                </div>
                <div className="checkout-account">
                    <div className="row">
                        <div className="col-12 col-md-6 text-center ff">
                            <div className="option-container">
                                <div
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                    }}
                                    className="ff"
                                >
                                    Guest Checkout
                                </div>
                                <div className="hr"></div>
                                <div style={{paddingTop: 6}}>You do not need an account to checkout.</div>
                                <div>
                                    <ul>
                                        <li>Pay safely with our secure guest checkout</li>
                                        <li>Easily track your order status</li>
                                        <li>If desired, you may create an account at the end of the checkout process</li>
                                    </ul>
                                </div>
                                <button
                                    id="checkout-as-guest"
                                    className={`btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''} pointer ff`}
                                    onClick={() => store.moveStep(ICheckoutStep.oci)}
                                    aria-label="Checkout as Guest"
                                >
                                    Continue as Guest
                                </button>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 text-center ff">
                            <div
                                className="option-container last"
                                style={{
                                    height: store.checkout.messages.filter(e => e.msgType === ICheckoutMessageType.login).length > 0 ? '390px' : '',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                    }}
                                    className="ff"
                                >
                                    Sign in to your account
                                </div>
                                <div className="hr"></div>
                                <div style={{paddingTop: 6}}>Sign in for a faster checkout and to save order history to your account</div>

                                <div className="text-left pad-top">
                                    <CheckoutInputElement
                                        ab={store.checkout.ab}
                                        o={store.checkout.email}
                                        type="email"
                                        autoFocus={false}
                                        required={true}
                                    />
                                </div>

                                <div className="text-left">
                                    <CheckoutInputElement
                                        ab={store.checkout.ab}
                                        o={store.checkout.pwd}
                                        type="password"
                                        autoFocus={false}
                                        required={true}
                                    />
                                </div>

                                {!this.loading &&
                                    store.checkout.messages
                                        .filter(e => e.msgType === ICheckoutMessageType.login)
                                        .map(e => (
                                            <div
                                                className="form-label"
                                                style={{color: 'red'}}
                                            >
                                                {e.msg}
                                            </div>
                                        ))}

                                <div
                                    style={{display: 'flex', justifyContent: 'space-between'}}
                                    className="member-container"
                                >
                                    <div style={{alignSelf: 'center', fontSize: 13, paddingLeft: 4}}>
                                        <a
                                            href="/home/login.aspx?pt=1"
                                            className="link"
                                            style={{fontSize: 13}}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Forgot Password?
                                        </a>
                                    </div>
                                    <div>
                                        <button
                                            className={`btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''} btn-checkout-member pointer ff`}
                                            onClick={this.signin}
                                            aria-label="Sign in"
                                        >
                                            Sign in
                                            {this.loading && (
                                                <span className="pad-left">
                                                    <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                                                </span>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
